// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/app.scss
// module id = 395
// module chunks = 0